import React, { useRef, useEffect } from 'react';
import { PinPath, Point } from "../Types";
import { clearCanvas, drawPath } from "../utils/pathDrawing";

interface PathPreviewProps {
    path?: PinPath;
    points: Point[];
    showTarget?: boolean;
    targetImageData?: ImageData;
    width: number;
    height: number;
}

export const PathPreview: React.FC<PathPreviewProps> = ({ 
    path, 
    points,
    showTarget = false, 
    targetImageData, 
    width, 
    height 
}) => {
    const canvasRef = useRef<HTMLCanvasElement>(null);

    useEffect(() => {
        const canvas = canvasRef.current;
        if (!canvas) return;

        // Ensure canvas has the correct dimensions
        canvas.width = width;
        canvas.height = height;

        const ctx = canvas.getContext("2d", { willReadFrequently: true })!;

        if (showTarget && targetImageData) {
            // Show target image
            ctx.putImageData(targetImageData, 0, 0);
        } else if (path && path.pinIndices.length > 1) {
            // Clear canvas and draw path using utility functions
            clearCanvas(ctx, width, height);
            drawPath(ctx, path, points);
        } else {
            // Initialize with white background if no path
            clearCanvas(ctx, width, height);
        }
    }, [path, points, showTarget, targetImageData, width, height]);

    return (
        <canvas 
            ref={canvasRef} 
            className="border border-gray-200 rounded shadow-sm max-w-full h-auto"
            style={{ maxWidth: '100%', height: 'auto' }}
        />
    );
};
